import type { FilaJukebox } from '../entities/FilaJukebox';

/**
 * Junta o snapshot de `listarAtivos` com o que o CDC aplicou durante o fetch.
 *
 * - Snapshot é a fonte dos IDs ativos no servidor no momento da query — para
 *   qualquer item de `prev` ausente do snapshot, o servidor é autoridade
 *   (mesma regra do Player em `useJukeboxQueue.reconciliarFilaComBanco`).
 * - IDs que o CDC marcou concluido/apagou durante o fetch não voltam,
 *   mesmo se ainda estiverem no snapshot (query começou antes do UPDATE).
 * - INSERTs que o CDC aplicou *durante esta janela de fetch* e o snapshot
 *   não viu entram no resultado — a ÚNICA exceção à autoridade do servidor.
 *   Sem restringir a essa janela, um item cujo evento de conclusão nunca
 *   chegou ao cliente (perdido antes desta janela) reaparecia a cada
 *   reconciliação por ainda parecer "pendente" localmente — inclusive no
 *   active sync de 3 min, que devolvia sempre o mesmo snapshot correto sem
 *   nunca conseguir removê-lo.
 */
export function mesclarFilaAposFetch(
  prev: readonly FilaJukebox[],
  snapshot: readonly FilaJukebox[],
  idsRemovidosDuranteFetch: ReadonlySet<string> = new Set(),
  idsInseridosDuranteFetch: ReadonlySet<string> = new Set(),
): FilaJukebox[] {
  const snapshotIds = new Set(snapshot.map(item => item.id));
  const resultado: FilaJukebox[] = [];

  for (const item of snapshot) {
    if (idsRemovidosDuranteFetch.has(item.id)) continue;
    resultado.push(item);
  }

  for (const item of prev) {
    if (snapshotIds.has(item.id)) continue;
    if (idsRemovidosDuranteFetch.has(item.id)) continue;
    if (!idsInseridosDuranteFetch.has(item.id)) continue;
    resultado.push(item);
  }

  return resultado.sort((a, b) => a.criado_em.localeCompare(b.criado_em));
}
